<template>
    <div class="text-[1.5rem] text-primary text-center py-4">
        A4 公司寄發EMAIL通知客戶約定保險金給付匯款帳戶
    </div>
    <div class="w-full max-w-[24rem] md:max-w-[29rem] mx-auto">
        <InputTypes
            v-model:value="id"
            type="text"
            :maxlength="10"
            label="帳號"
        />
    </div>
    <div class="w-full max-w-[24rem] md:max-w-[29rem] mx-auto">
        <InputTypes
            v-model:value="a4.changeId"
            type="text"
            :maxlength="10"
            label="changeId"
        />
    </div>
    <div class="w-full max-w-[24rem] md:max-w-[29rem] mx-auto">
        <InputTypes
            v-model:value="a4.srceFrom"
            type="text"
            :maxlength="1"
            label="srceFrom"
        />
    </div>
    <div class="w-full max-w-[24rem] md:max-w-[29rem] mx-auto">
        <InputTypes
            v-model:value="a4.payCod"
            :maxlength="1"
            type="text"
            label="payCod"
        />
    </div>
    <div class="w-full max-w-[24rem] md:max-w-[29rem] mx-auto">
        <InputTypes
            v-model:value="a4.poliDate"
            :maxlength="8"
            type="text"
            label="poliDate"
        />
    </div>
    <div class="w-full max-w-[24rem] md:max-w-[29rem] mx-auto">
        <InputTypes
            v-model:value="a4.rtnDate"
            :maxlength="8"
            type="text"
            label="rtnDate"
        />
    </div>
    <div class="flex justify-center pt-2">
        <button
            class="btn w-full rounded-full gradient-primary border-0 max-w-[8.75rem]"
            @click.prevent="postApi"
        >
            確定
        </button>
    </div>
    <Loading :isLoading="isLoading" />
</template>

<script>
import { reactive, toRefs, inject } from 'vue';
import { useRoute } from 'vue-router';
import { postSSOInput } from '@/apis/ssoInput';
import InputTypes from '@/components/inputs/InputTypes.vue';

export default {
    components: {
        InputTypes,
    },
    setup() {
        const $vfm = inject('$vfm');
        const route = useRoute();
        const users = reactive({
            id: '',
            aplCatl: 'A4',
            sysAuthCode: '',
            transactionItemNo: '',
            policyNo: '',
            policySeq: '',
            idDup: '',
            srceFrom: '',
            action: '',
            noErrorMsg: '',
            source: 'A4',
            a4: {
                changeId: route?.query?.changeId,
                srceFrom: route?.query?.srceFrom,
                payCod: route?.query?.payCod,
                poliDate: route?.query?.poliDate,
                rtnDate: route?.query?.rtnDate
            },
            isLoading: false,
        });

        const postApi = async (canPost) => {
            if (canPost) {
                users.isLoading = true;
                const path = process.env.VUE_APP_CONTEXT_PATH;
                const baseUrl = `${window.location.origin}${path}`;
                const data = {
                    id: users.id,
                    aplCatl: users.aplCatl,
                    source: users.source,
                    sysAuthCode: users.sysAuthCode,
                    transactionItemNo: users.transactionItemNo,
                    policyNo: users.policyNo,
                    policySeq: users.policySeq,
                    idDup: users.idDup,
                    srceFrom: users.srceFrom,
                    action: users.action,
                    a4: users.a4,
                    a5: null
                };
                postSSOInput(data).then(res => {
                    window.location.href = `${baseUrl}/ssoLogin?param=${res.data.token}`;
                }).catch(err => {
                    openPopup(err.data?.errorMessage);
                }).finally(() => {
                    users.isLoading = false;
                });
            }
        };

        const openPopup = (errorMessage) => {
            $vfm.show({
                component: 'DialogBase',
                params: {
                    title: '系統提示',
                    content: errorMessage || '系統忙碌中，請稍後再試',
                    confirmButton: '確認',
                    cancelButton: null,
                    closeicon: true,
                },
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    },
                }
            });
        };

        return {
            ...toRefs(users),
            postApi
        };
    },
};
</script>
